module.exports = __webpack_public_path__ + "static/img/__9137.bc7bc8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9137.jpg
// module id = sfhZ
// module chunks = 0